"use client";
import React, { FC } from "react";
import useOnScreen from "@/src/hooks/useOnScreen";
import { getTranslateClass } from "@/src/constants/animations";
import { AnimatedTextProps } from "./types";

const AnimatedText: FC<AnimatedTextProps> = ({
  children,
  direction,
  className = "",
  center = false,
}) => {
  const { ref, isIntersecting } = useOnScreen<HTMLDivElement>(0.1, true);

  return (
    <div
      ref={ref}
      className={`w-full ${
        center ? "" : "md:w-1/2"
      } transition-transform duration-700 ease-in-out ${
        isIntersecting
          ? "translate-x-0 translate-y-0 opacity-100"
          : `${getTranslateClass(direction)} opacity-0`
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default AnimatedText;
